import React from 'react';
// // - MENU ICONS
// import Badge from '../commons/badge/Badge';
// permissions
import { GROUPS, /* CENE_CLIENT_ID, */ ACCESS } from 'app/config/consts';
import { MENU } from 'app/config/mainMenu';
import HealthProfessional from 'app/components/pages/health-professional/HealthProfessional.jsx';
// - ROUTES COMPONENTS
const Users = React.lazy(() => import('app/components/pages/users/Users'));
const Clients = React.lazy(() => import('app/components/pages/clients/Clients'));
const Permissions = React.lazy(() => import('app/components/pages/permissions/Permissions'));
const Patients = React.lazy(() => import('app/components/pages/patients/Patients.jsx'));
const PatientDetail = React.lazy(() => import('app/components/pages/patient-detail/PatientDetail'));
// const Visitation = React.lazy(() => import('app/components/pages/visits/Visitation'));
const Visitation = React.lazy(() =>
  import('app/components/pages/visits/visits-list/VisitsListPage')
);
const VisitsInitialAssessment = React.lazy(() =>
  import('app/components/pages/visits/visits-initial-assessment/VisitsInitialAssessment')
);
const VisitationDetail = React.lazy(() =>
  import('app/components/pages/visit-detail/VisitDetailPage')
);
const PadModelCreator = React.lazy(() =>
  import('app/components/pages/pad-menu/pad-models/pad-model-creator/PadModelCreator')
);
const PadModelEditor = React.lazy(() =>
  import('app/components/pages/pad-menu/pad-models/pad-model-editor/PadModelEditor')
);

/*const Notifications = React.lazy(() =>import('app/components/pages/notifications/Notifications'));*/
const HealthInsurance = React.lazy(() =>
  import('app/components/pages/health-insurance/HealthInsurance')
);
const PEPListPage = React.lazy(() =>
  import('app/components/pages/pep-menu/pep-list-page/PEPListPage')
);
// const ElectronicHealthRecord = React.lazy(() =>
//   import('app/components/pages/pep-menu/ElectronicHealthRecord')
// );
const PEPPage = React.lazy(() => import('app/components/pages/pep-menu/pep-page/PEPPage'));
// const Pep = React.lazy(() => import('app/components/pages/pep-menu/Pep'));

// -----------------------------------------------------------------------------
//                              DASHBOARD
// -----------------------------------------------------------------------------
const VisitDashboard = React.lazy(() =>
  import('app/components/pages/visit-dashboard/VisitDashboard')
);
const PrescritpionMenu = React.lazy(() =>
  import('app/components/pages/prescription-menu/PrescriptionMenu')
);
const PadDashboard = React.lazy(() => import('app/components/pages/pad-dashboard/PadDashboard'));
// -----------------------------------------------------------------------------

const PlanVisitForm = React.lazy(() => import('app/components/pages/visit-form/PlanVisitForm'));
const NotFound = React.lazy(() => import('app/components/pages/notfound/NotFound'));
const ProfessionalAvailability = React.lazy(() =>
  import('app/components/pages/professional-availability/ProfessionalAvailability')
);
const Routing = React.lazy(() => import('app/components/pages/routing/Routing'));
const RoutingMap = React.lazy(() => import('app/components/pages/routing/RoutingMap'));
const Monitoring = React.lazy(() => import('app/components/pages/monitoring/Monitoring'));
const BusinessPartner = React.lazy(() =>
  import('app/components/pages/business-partner/BusinessPartner')
);
const Cid = React.lazy(() => import('app/components/pages/cid/Cid'));
const Kit = React.lazy(() => import('app/components/pages/kit/Kit'));
const KitMatMed = React.lazy(() => import('app/components/pages/kit/KitMatMed'));
const Equipment = React.lazy(() => import('app/components/pages/equipment/Equipment'));
const MatMed = React.lazy(() => import('app/components/pages/MatMed/MatMed'));
const Furniture = React.lazy(() => import('app/components/pages/furniture/Furniture'));
const NandaDomain = React.lazy(() => import('app/components/pages/nanda-domain/NandaDomain'));
const NandaClass = React.lazy(() => import('app/components/pages/nanda-class/NandaClass'));
const NandaDiagnostic = React.lazy(() =>
  import('app/components/pages/nanda-diagnostic/NandaDiagnostic')
);
const Attendances = React.lazy(() => import('app/components/pages/attendances/Attendances'));
const Profession = React.lazy(() => import('app/components/pages/profession/Profession'));
// PAD
const PadCreator = React.lazy(() => import('app/components/pages/pad-menu/pad-creator/PadCreator'));
const PadEditor = React.lazy(() => import('app/components/pages/pad-menu/pad-editor/PadEditor'));
const ReschedulePad = React.lazy(() =>
  import('app/components/pages/pad-menu/reschedule-pad/ReschedulePad')
);
const PadMenu = React.lazy(() => import('app/components/pages/pad-menu'));
const Pad = React.lazy(() => import('app/components/pages/pad-menu/pad/Pad'));
// const Item = React.lazy(() => import('app/components/pages/item/Item'));
const Procedure = React.lazy(() => import('app/components/pages/procedures/Procedure'));
const MeasurementUnits = React.lazy(() =>
  import('app/components/pages/measurement-unity/MeasurementUnity')
);
const Evaluation = React.lazy(() => import('app/components/pages/evaluation/Evaluation'));
const ServiceProducts = React.lazy(() =>
  import('app/components/pages/service-products/ServiceProducts')
);
const PreviewEvaluation = React.lazy(() =>
  import('app/components/pages/preview-evaluation/PreviewEvaluation')
);
const PadModels = React.lazy(() => import('app/components/pages/pad-menu/pad-models/PadModels'));
const AdministrationRoute = React.lazy(() =>
  import('app/components/pages/administration-route/AdministrationRoute')
);
const InitializeClient = React.lazy(() =>
  import('app/components/pages/pad-menu/initialize-pad/initialize-client')
);
/* const InitializeCooperative = React.lazy(() =>
  import('app/components/pages/pad-menu/initialize-pad/initialize-cooperative')
); */
const PadInitializationClient = React.lazy(() =>
  import('app/components/pages/pad-menu/pad-initialization/initialize-client')
);
const PadInitializationCooperative = React.lazy(() =>
  import('app/components/pages/pad-menu/pad-initialization/initialize-cooperative')
);
// -----------------------------------------------------------------------------
//                          REPORTS
// -----------------------------------------------------------------------------
const Report = React.lazy(() =>
  import('app/components/pages/reports/extension-report/PageVisitReport')
);
const ReportConfiguration = React.lazy(() =>
  import('app/components/pages/reports/report-configuration/ReportConfiguration')
);
const ReportGeneration = React.lazy(() =>
  import('app/components/pages/reports/report-generation/ReportGeneration')
);
const ReportProduction = React.lazy(() =>
  import('app/components/pages/reports/report-production/ReportProduction')
);
const VerificationReport = React.lazy(() =>
  import('app/components/pages/reports/verificaton-report/VerificationReport')
);
// -----------------------------------------------------------------------------

const Branch = React.lazy(() => import('app/components/pages/branch/Branch'));
const VisitationType = React.lazy(() =>
  import('app/components/pages/visitation-type/VisitationType.jsx')
);
const SignSymptom = React.lazy(() => import('app/components/pages/sign-symptom/SignSymptom'));
const HealthSandardsReports = React.lazy(() =>
  import('app/components/pages/reports/health-standards-reports/HealthStandardsReports')
);

const PageMap = React.lazy(() =>
  import('app/components/modals/visit-detail/checkingCheckoutModal/map/PageMap')
);

const ROUTES = [
  // MENU DASHBOARD

  {
    exact: true,
    path: '/map',
    component: PageMap,
    icon: null,
    title: 'map',
    canAccess: [
      GROUPS.SALVUS_ADMIN,
      GROUPS.GROUP_ADMIN,
      GROUPS.GROUP_DEFAULT
      // GROUPS.BUSINESS_PARTNER,
    ],
    whoCanAccess: [ACCESS.CLIENT, ACCESS.BUSINESS_PARTNER]
  },
  {
    exact: true,
    path: '/visit-dashboard',
    component: VisitDashboard,
    icon: null,
    title: 'Painel de Visitas',
    canAccess: [
      GROUPS.SALVUS_ADMIN,
      GROUPS.GROUP_ADMIN,
      GROUPS.GROUP_DEFAULT,
      GROUPS.PROFESSIONAL
      // GROUPS.BUSINESS_PARTNER,
    ],
    whoCanAccess: [ACCESS.CLIENT, ACCESS.BUSINESS_PARTNER],
    section: MENU.DASHBOARD
  },
  {
    exact: true,
    path: '/pad-dashboard',
    component: PadDashboard,
    icon: null,
    title: 'PAINEL DOS PADS',
    canAccess: [
      GROUPS.SALVUS_ADMIN,
      GROUPS.GROUP_ADMIN,
      GROUPS.GROUP_DEFAULT
      // GROUPS.BUSINESS_PARTNER,
    ],
    whoCanAccess: [ACCESS.CLIENT],
    section: MENU.DASHBOARD
  },
  {
    exact: true,
    path: '/prescription-menu',
    component: PrescritpionMenu,
    icon: null,
    title: 'Painel de Prescrições',
    canAccess: [
      GROUPS.SALVUS_ADMIN,
      GROUPS.GROUP_ADMIN,
      GROUPS.GROUP_DEFAULT
      // GROUPS.BUSINESS_PARTNER,
    ],
    whoCanAccess: [ACCESS.CLIENT /* , ACCESS.BUSINESS_PARTNER */],
    section: MENU.DASHBOARD
  },
  // VISITATION
  {
    /* EXPLANATION
      Devido à lentidão do sistema a página principal passou a ser
      de Listagem de Visita ,
    */
    exact: true,
    path: '/',
    component: Visitation,
    icon: null,
    title: 'Listagem',
    canAccess: [
      GROUPS.SALVUS_ADMIN,
      GROUPS.GROUP_ADMIN,
      GROUPS.GROUP_DEFAULT,
      GROUPS.PROFESSIONAL
      // GROUPS.BUSINESS_PARTNER,
    ],
    whoCanAccess: [ACCESS.CLIENT, ACCESS.BUSINESS_PARTNER],
    section: MENU.VISIT
  },
  {
    /* EXPLANATION
      Devido à lentidão do sistema a página principal passou a ser
      de Listagem de Visita ,
    */
    exact: true,
    path: '/visitation',
    component: Visitation,
    canAccess: [
      GROUPS.SALVUS_ADMIN,
      GROUPS.GROUP_ADMIN,
      GROUPS.GROUP_DEFAULT,
      GROUPS.PROFESSIONAL
      // GROUPS.BUSINESS_PARTNER,
    ],
    whoCanAccess: [ACCESS.CLIENT, ACCESS.BUSINESS_PARTNER]
  },
  {
    exact: true,
    path: '/professional-availability',
    component: ProfessionalAvailability,
    icon: null, //calendarVisitsIcon,
    title: 'Calendário de visitas',
    canAccess: [
      GROUPS.SALVUS_ADMIN,
      GROUPS.GROUP_ADMIN,
      GROUPS.GROUP_DEFAULT
      // GROUPS.BUSINESS_PARTNER,
    ],
    whoCanAccess: [ACCESS.CLIENT, ACCESS.BUSINESS_PARTNER],
    section: MENU.VISIT
  },
  {
    exact: true,
    path: '/routing',
    component: Routing,
    icon: null,
    title: 'Roteirização',
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT],
    section: MENU.VISIT
  },
  {
    exact: true,
    path: '/visitation-type',
    component: VisitationType,
    icon: null,
    title: 'Tipos de Visitas',
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT],
    section: MENU.VISIT
  },
  {
    exact: true,
    path: '/evaluation-type',
    component: Evaluation,
    icon: null,
    title: 'Tipos de Avaliações',
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT],
    section: MENU.VISIT
  },
  {
    exact: true,
    path: '/visits/:id',
    component: VisitationDetail,
    icon: null,
    canAccess: [
      GROUPS.SALVUS_ADMIN,
      GROUPS.GROUP_ADMIN,
      GROUPS.GROUP_DEFAULT,
      GROUPS.PROFESSIONAL
      // GROUPS.BUSINESS_PARTNER,
    ],
    whoCanAccess: [ACCESS.CLIENT, ACCESS.BUSINESS_PARTNER]
  },
  {
    exact: true,
    path: '/visits-initial-assessment/:id',
    component: VisitsInitialAssessment,
    icon: null,
    canAccess: [
      GROUPS.SALVUS_ADMIN,
      GROUPS.GROUP_ADMIN,
      GROUPS.GROUP_DEFAULT
      // GROUPS.BUSINESS_PARTNER,
    ],
    whoCanAccess: [ACCESS.CLIENT, ACCESS.BUSINESS_PARTNER]
  },
  {
    exact: true,
    path: '/routing/:id',
    component: RoutingMap,
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT]
  },
  {
    exact: true,
    path: '/bind-professional/:id',
    component: PadInitializationCooperative,
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.BUSINESS_PARTNER]
  },
  {
    exact: true,
    path: '/plan-visit',
    component: PlanVisitForm,
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN],
    whoCanAccess: [ACCESS.CLIENT]
  },
  // PAD
  {
    exact: true,
    path: '/pad-creator',
    component: PadCreator,
    icon: null,
    title: 'CRIAÇÃO DE PADS',
    canAccess: [
      GROUPS.SALVUS_ADMIN,
      GROUPS.GROUP_ADMIN,
      GROUPS.GROUP_DEFAULT
      // GROUPS.BUSINESS_PARTNER,
    ],
    whoCanAccess: [ACCESS.CLIENT]
    // section: MENU.PAD
  },
  {
    exact: true,
    path: '/pad',
    component: PadMenu,
    icon: null,
    title: 'Listagem',
    canAccess: [
      GROUPS.SALVUS_ADMIN,
      GROUPS.GROUP_ADMIN,
      GROUPS.GROUP_DEFAULT
      // GROUPS.BUSINESS_PARTNER,
    ],
    whoCanAccess: [ACCESS.CLIENT, ACCESS.BUSINESS_PARTNER],
    section: MENU.PAD
  },
  {
    exact: true,
    path: '/attendance',
    component: Attendances,
    icon: null,
    title: 'Atendimento',
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT],
    section: MENU.PAD
  },
  {
    exact: true,
    path: '/preview-evaluation',
    component: PreviewEvaluation,
    icon: null,
    title: 'Prévia de Avaliação',
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT],
    section: MENU.PAD
  },
  {
    exact: true,
    path: '/pad-models',
    component: PadModels,
    icon: null,
    title: 'Modelos',
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT],
    section: MENU.PAD
  },
  {
    exact: true,
    path: '/pad-model-editor/:id',
    component: PadModelEditor,
    icon: null,
    title: 'Modelos',
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT]
    // section: MENU.PAD
  },
  {
    exact: true,
    path: '/create-model',
    component: PadModelCreator,
    icon: null,
    canAccess: [
      GROUPS.SALVUS_ADMIN,
      GROUPS.GROUP_ADMIN,
      GROUPS.GROUP_DEFAULT,
      GROUPS.PROFESSIONAL
      // GROUPS.BUSINESS_PARTNER,
    ],
    whoCanAccess: [ACCESS.CLIENT, ACCESS.BUSINESS_PARTNER]
  },
  {
    exact: true,
    path: '/pad/:id',
    component: Pad,
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT]
  },
  {
    exact: true,
    path: '/pad-editor/:id',
    component: PadEditor,
    icon: null,
    canAccess: [
      GROUPS.SALVUS_ADMIN,
      GROUPS.GROUP_ADMIN,
      GROUPS.GROUP_DEFAULT
      // GROUPS.BUSINESS_PARTNER,
    ],
    whoCanAccess: [ACCESS.CLIENT]
  },
  {
    exact: true,
    path: '/reschedule-pad/:id',
    component: ReschedulePad,
    icon: null,
    canAccess: [
      GROUPS.SALVUS_ADMIN,
      GROUPS.GROUP_ADMIN,
      GROUPS.GROUP_DEFAULT
      // GROUPS.BUSINESS_PARTNER,
    ],
    whoCanAccess: [ACCESS.CLIENT]
  },
  {
    exact: true,
    path: '/pad-monitoring/:id',
    component: Monitoring,
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT]
  },
  {
    exact: true,
    path: '/initialize-pad/:id',
    component: InitializeClient,
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT]
  },
  {
    exact: true,
    path: '/pad-initialization/:id',
    component: PadInitializationClient,
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT]
  },
  {
    exact: true,
    path: '/nanda-class',
    component: NandaClass,
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT]
  },
  {
    exact: true,
    path: '/nanda-domain',
    component: NandaDomain,
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT]
  },

  // PEPPage
  {
    exact: true,
    path: '/pep',
    component: PEPListPage,
    // component: ElectronicHealthRecord,
    icon: null,
    title: 'Prontuário Eletrônico',
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT, GROUPS.PROFESSIONAL],
    whoCanAccess: [ACCESS.CLIENT],
    section: MENU.PEP
  },
  {
    exact: true,
    path: '/pep/:id',
    component: PEPPage,
    // component: Pep,
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT, GROUPS.PROFESSIONAL],
    whoCanAccess: [ACCESS.CLIENT]
  },
  {
    exact: true,
    path: '/equipment',
    component: Equipment,
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT]
  },
  {
    exact: true,
    path: '/mat-med',
    component: MatMed,
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT]
  },
  {
    exact: true,
    path: '/kit',
    component: Kit,
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT]
  },
  {
    exact: true,
    path: '/kit-mat-med/kit/:id',
    component: KitMatMed,
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT]
  },
  // REPORT
  {
    exact: true,
    path: '/configuration',
    component: ReportConfiguration,
    icon: null,
    title: 'Configuração',
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT],
    section: MENU.REPORT
  },
  {
    exact: true,
    path: '/visit-report',
    component: Report,
    icon: null,
    title: 'Visitas',
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT],
    section: MENU.REPORT
  },
  {
    exact: true,
    path: '/health-sandards-reports',
    component: HealthSandardsReports,
    icon: null,
    title: 'Padrões de Saúde',
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT],
    section: MENU.REPORT
  },
  {
    exact: true,
    path: '/report-production',
    component: ReportProduction,
    title: 'Produção',
    canAccess: [
      GROUPS.SALVUS_ADMIN,
      GROUPS.GROUP_ADMIN,
      GROUPS.GROUP_DEFAULT,
      GROUPS.BUSINESS_PARTNER
    ],
    whoCanAccess: [ACCESS.CLIENT, ACCESS.BUSINESS_PARTNER],
    section: MENU.REPORT
    // icon: <Badge name={'BETA'} />
  },
  {
    exact: true,
    path: '/varification-report',
    component: VerificationReport,
    title: 'Relatório de Checagem',
    canAccess: [
      GROUPS.SALVUS_ADMIN,
      GROUPS.GROUP_ADMIN,
      GROUPS.GROUP_DEFAULT
      // GROUPS.BUSINESS_PARTNER
    ],
    whoCanAccess: [ACCESS.CLIENT, ACCESS.BUSINESS_PARTNER],
    section: MENU.REPORT
  },
  // {
  //   exact: true,
  //   path: '/report-productivity',
  //   component: ReportProductivity,
  //   icon: null,
  //   title: 'Produtividade',
  //   canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
  //   whoCanAccess: [ACCESS.CLIENT],
  //   section: MENU.REPORT
  // },
  {
    exact: true,
    path: '/generation',
    component: ReportGeneration,
    icon: null,
    title: 'Emissão em Massa',
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT],
    section: MENU.REPORT
  },
  // USERS
  {
    exact: true,
    path: '/patients',
    component: Patients,
    icon: null,
    title: 'Pacientes',
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT],
    section: MENU.USERS
  },
  {
    exact: true,
    path: '/patients/:id',
    component: PatientDetail,
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT]
  },
  {
    exact: true,
    path: '/health-professional',
    component: HealthProfessional,
    icon: null,
    title: 'Profissionais de Saúde',
    canAccess: [
      GROUPS.SALVUS_ADMIN,
      GROUPS.GROUP_ADMIN,
      GROUPS.GROUP_DEFAULT
      // GROUPS.BUSINESS_PARTNER,
    ],
    whoCanAccess: [ACCESS.CLIENT, ACCESS.BUSINESS_PARTNER],
    section: MENU.USERS
  },
  {
    exact: true,
    path: '/users',
    component: Users,
    icon: null,
    title: 'Usuários Web',
    canAccess: [
      GROUPS.SALVUS_ADMIN,
      GROUPS.GROUP_ADMIN,
      GROUPS.GROUP_DEFAULT
      // GROUPS.BUSINESS_PARTNER,
    ],
    whoCanAccess: [ACCESS.CLIENT, ACCESS.BUSINESS_PARTNER],
    section: MENU.USERS
  },
  {
    exact: true,
    path: '/business-partner',
    component: BusinessPartner,
    icon: null,
    title: 'Parceiro de Negócio',
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT],
    section: MENU.USERS
  },
  //ORGANIZATIONAL
  {
    exact: true,
    path: '/branch',
    component: Branch,
    icon: null,
    title: 'Filiais',
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT],
    section: MENU.ORGANIZATIONAL
  },
  {
    exact: true,
    path: '/health-insurance',
    component: HealthInsurance,
    icon: null,
    title: 'Operadoras',
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT],
    section: MENU.ORGANIZATIONAL
  },
  {
    exact: true,
    path: '/permissions',
    component: Permissions,
    icon: null,
    title: 'Permissões',
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN],
    whoCanAccess: [ACCESS.CLIENT],
    section: MENU.ORGANIZATIONAL
  },
  {
    exact: true,
    path: '/profession',
    component: Profession,
    icon: null,
    title: 'Profissões',
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT],
    section: MENU.ORGANIZATIONAL
  },
  {
    exact: true,
    path: '/service-product',
    component: ServiceProducts,
    icon: null,
    title: 'Serviços',
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT],
    section: MENU.ORGANIZATIONAL
  },
  {
    exact: true,
    path: '/clients',
    component: Clients,
    icon: null,
    title: 'Clientes',
    canAccess: [GROUPS.SALVUS_ADMIN],
    whoCanAccess: [ACCESS.CLIENT],
    section: MENU.HEALTH_PLAN
  },
  // REGISTRATION
  {
    exact: true,
    path: '/equipment',
    component: Equipment,
    icon: null,
    title: 'Equipamentos',
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT],
    section: MENU.REGISTRATION
  },
  {
    exact: true,
    path: '/kits',
    component: Kit,
    icon: null,
    title: 'Kits',
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT],
    section: MENU.REGISTRATION
  },
  {
    exact: true,
    path: '/mat-med',
    component: MatMed,
    icon: null,
    title: 'Mat/Med',
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT],
    section: MENU.REGISTRATION
  },
  {
    exact: true,
    path: '/furniture',
    component: Furniture,
    icon: null,
    title: 'Mobiliários',
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT],
    section: MENU.REGISTRATION
  },
  {
    exact: true,
    path: '/procedures',
    component: Procedure /*KitProcedure,*/,
    icon: null,
    title: 'Procedimentos',
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT],
    section: MENU.REGISTRATION
  },
  {
    exact: true,
    path: '/measurement-units',
    component: MeasurementUnits,
    icon: null,
    title: 'Unidades de medida',
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT],
    section: MENU.REGISTRATION
  },
  {
    exact: true,
    path: '/administration-route',
    component: AdministrationRoute,
    icon: null,
    title: 'Vias de Administração',
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT],
    section: MENU.REGISTRATION
  },
  // TERMINOLOGY
  {
    exact: true,
    path: '/cid',
    component: Cid,
    icon: null,
    title: 'CIDs',
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT],
    section: MENU.TERMINOLOGY
  },
  {
    exact: true,
    path: '/nanda-diagnostic',
    component: NandaDiagnostic,
    icon: null,
    title: 'Diagnóstico Nanda',
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT],
    section: MENU.TERMINOLOGY
  },
  {
    exact: true,
    path: '/sign-symptom',
    component: SignSymptom,
    icon: null,
    title: 'Sinais e Sintomas',
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT],
    section: MENU.TERMINOLOGY
  },

  {
    exact: false,
    path: '*',
    component: NotFound,
    canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
    whoCanAccess: [ACCESS.CLIENT, ACCESS.BUSINESS_PARTNER]
  }
];

// {
//   exact: true,
//   path: '/pad-monitoring/:id',
//   component: PadMonitoring,
//   canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
//   whoCanAccess: [ACCESS.CLIENT]
// },

/*
{
 exact: true,
 path: '/notifications',
 component: Notifications,
 icon: null,
 title: 'Notificações',
 canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
 whoCanAccess: [ACCESS.CLIENT],
 section: MENU.HEALTH_PLAN,
},
*/
// {
//   exact: true,
//   path: '/report/productivity',
//   component: ReportProductivity,
//   icon: null,
//   title: 'Produtividade',
//   canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
//   whoCanAccess: [ACCESS.CLIENT],
//   section: MENU.REPORT
// },

/*function isMenuVisible(route, account) {
  return route.title !== undefined &&
    route.canAccess.length &&
    route.section !== undefined
    ? route.canAccess.indexOf(account.groupId) !== -1
    : route.canAccess === account.groupId;
}
*/
// /**
//  *
//  * @param {*} account
//  */
// export function getRoutes(account) {
//   if (CENE_CLIENT_ID.includes(account.clientId)) {
//     return ROUTES.filter(
//       r => r.grupoCene === true || r.grupoCene === undefined
//     );
//   } else {
//     return ROUTES.filter(r => r.grupoCene !== true);
//   }
// }
// {
//   exact: true,
//   path: '/schedule-cooperative-visit/pad/:id',
//   component: ScheduleCooperativeVisit,
//   canAccess: [
//     GROUPS.SALVUS_ADMIN,
//     GROUPS.GROUP_ADMIN,
//     GROUPS.GROUP_DEFAULT
//     // GROUPS.BUSINESS_PARTNER,
//   ],
//   whoCanAccess: [ACCESS.CLIENT, ACCESS.BUSINESS_PARTNER]
// },
// {
//   exact: true,
//   path: '/item',
//   component: Item,
//   icon: null,
//   title: 'Itens',
//   canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
//   whoCanAccess: [ACCESS.CLIENT],
//   section: MENU.REGISTRATION
// },
// {
//   exact: true,
//   path: '/evaluation-type/:id',
//   component: EvaluationForm,
//   canAccess: [GROUPS.SALVUS_ADMIN, GROUPS.GROUP_ADMIN, GROUPS.GROUP_DEFAULT],
//   whoCanAccess: [ACCESS.CLIENT]
// },
/* {
  exact: true,
  path: '/link-professional/:id',
  component: LinkProfessional,
  icon: null,
  canAccess: [
    GROUPS.SALVUS_ADMIN,
    GROUPS.GROUP_ADMIN,
    GROUPS.GROUP_DEFAULT
    // GROUPS.BUSINESS_PARTNER,
  ],
  whoCanAccess: [ACCESS.CLIENT, ACCESS.BUSINESS_PARTNER]
}, */

/**
 *
 * @param {*} account
 */
export function getRoutes(account) {
  const { groupId, businessPartnerId } = account;

  const groupFilter = ROUTES.filter(r => r.canAccess.includes(groupId));

  if (businessPartnerId !== null)
    return groupFilter.filter(r => r.whoCanAccess.includes(ACCESS.BUSINESS_PARTNER));

  return groupFilter;
}

export function getMenu(account) {
  return getRoutes(account);
}
